import {Directive, ElementRef, HostListener, Input, OnInit, Optional, Renderer2} from "@angular/core";
import {NgControl} from "@angular/forms";

@Directive({
    selector: "[formControlName][appCurrencyMask], [currencyMask]",
    standalone: false
})
export class CurrencyMaskDirective implements OnInit {
  constructor(public el: ElementRef, private renderer: Renderer2, @Optional() public ngControl: NgControl) {
  }
  hasManualVal;

  @Input() otherMeasurement: string;
  @Input('symbol') set symbol(sym) {
    if (sym) {
      this.charSymb = sym;
      this.onInputChange(this.el.nativeElement.value || this.el.nativeElement.innerHTML, false);
      if(this.hasManualVal){
        this.manualValue = this.el.nativeElement.innerHTML;
      }
    }
  };
  charSymb = '$';

  @Input('manualValue') set manualValue(value) {
    if (value) {
      this.hasManualVal = true
      const newValue = this._updateValue(value, false);
      this.renderer.setProperty(this.el.nativeElement, 'textContent', newValue);
    }
  };

  ngOnInit() {
    this.onInputChange(this.el.nativeElement.value, false);
  }

  @HostListener("ngModelChange", ["$event"])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
    if (allowedKeys.includes(event.key)) {
      if (event.key === "Backspace" && this.otherMeasurement) {
        this.handleBackspaceWithMeasurement(event);
      }
      return;
    }

    if (
      !/[0-9.]/.test(event.key) || // Allow only numbers and decimal point
      (event.key === "." && this.el.nativeElement.value.replace(this.charSymb, "").includes(".")) // Allow only one decimal point
    ) {
      event.preventDefault();
    }
  }

  handleBackspaceWithMeasurement(event: KeyboardEvent) {
    const currentValue = this.el.nativeElement.value;
    if (currentValue.endsWith(` ${this.otherMeasurement}`)) {
      event.preventDefault();
      const updatedValue = currentValue.slice(0, -this.otherMeasurement.length - 1);
      this.onInputChange(updatedValue, true);
    }
  }

  onInputChange(event, backspace) {
    const value = this._updateValue(event, backspace)

    if (this.ngControl && this.ngControl.valueAccessor) {
      this.ngControl.valueAccessor.writeValue(value);
    }
  }

  private _updateValue(event, backspace) {
    if (!event) {
      return;
    }
    let newVal = event.replace(/[^0-9.]/g, "");
    newVal = newVal.replace(/^\./, "");

    if (backspace && newVal.length <= 6) {
      newVal = newVal.substring(0, newVal.length - 1);
    }

    const parts = newVal.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    newVal = parts.join(".");
    let value: string;
    if (this.otherMeasurement) {
      value = newVal ? newVal + ' ' + this.otherMeasurement : newVal;
    } else {
      value = newVal ? this.charSymb + ' ' + newVal : newVal;
    }
    return value || ''
  }
}
